var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.137 120 120 93.137 120 60C120 26.863 93.137 0 60 0C26.863 0 0 26.863 0 60C0 93.137 26.863 120 60 120Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3453 62.9359C29.3593 59.0724 37.1888 55.8479 44.5043 52.6069C57.0898 47.2984 69.7253 42.0819 82.4883 37.2254C84.9715 36.3979 89.4333 35.5886 89.8708 39.2686C89.6313 44.4776 88.6458 49.6561 87.9698 54.8347C86.254 66.2227 84.271 77.5716 82.3373 88.9221C81.671 92.7029 76.9348 94.6601 73.9043 92.2406C66.6213 87.3211 59.2823 82.4496 52.0923 77.4161C49.737 75.0229 51.921 71.5862 54.0245 69.8772C60.023 63.9657 66.3845 58.9431 72.0695 52.7262C73.603 49.0229 69.072 52.1439 67.5775 53.1001C59.3655 58.7591 51.3545 64.7636 42.6965 69.7371C38.274 72.1716 33.1195 70.0911 28.699 68.7327C24.7355 67.0917 18.9274 65.4384 22.3449 62.9361L22.3453 62.9359Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 45.007,
    y1: 5.004,
    x2: 15.007,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.09fb9924.svg";
export { ForwardRef as ReactComponent };